import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcPositive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 2c7.732 0 14 6.268 14 14s-6.268 14-14 14S2 23.732 2 16 8.268 2 16 2Zm0 2C9.373 4 4 9.373 4 16s5.373 12 12 12 12-5.373 12-12S22.627 4 16 4Zm6.22 6.375 1.56 1.25-8.697 10.872-5.79-5.79 1.414-1.414 4.21 4.209 7.302-9.127Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
export default SvgIcPositive;
